const Contact = () => {
  return (
    <section id="contact" className="px-6 md:px-28 py-24 bg-slate-900 ">
      <div className="flex">
        <div className="bg-primary h-9 w-2 mr-3" />
        <p className="text-4xl font-bold">Contact</p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 my-12">
        <div className="bg-black py-6 px-4 md:px-8">
          <p className="text-xl font-bold mb-4">Get in Touch</p>
          <p>
            I believe in creativity and being exceptional while at it. Contact
            me let's talk about your next project.
          </p>

          <div className="flex mb-4 items-center mt-8">
            <div className="bg-primary w-9 h-9 mr-4 flex justify-center items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                dataSlot="icon"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
                />
              </svg>
            </div>
            <p className="text-sm text-gray-400">0813 253 0997</p>
          </div>
          <div className="flex mb-4 items-center">
            <div className="bg-primary w-9 h-9 mr-4 flex justify-center items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                dataSlot="icon"
                className="w-6 h-6"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
                />
              </svg>
            </div>
            <p className="text-sm text-gray-400">anselmchizurum@gmail.com</p>
          </div>
        </div>
        <div className="bg-black py-6 px-4 md:px-8">
          <p className="text-xl font-bold mb-4">Follow me</p>
          <div className="mb-2">
            <p className="text-lg font-bold mb-1">Github</p>
            <div className="flex">
              <img src="github.png" alt="github" height={24} width={24} />
              <a href="https://github.com/Xelem" className="ml-4">
                https://github.com/Xelem
              </a>
            </div>
          </div>
          <div className="mb-2">
            <p className="text-lg font-bold mb-1">Twitter</p>
            <div className="flex">
              <img src="x.png" alt="twitter" height={24} width={24} />
              <a href="https://twitter.com/xel_em_" className="ml-4">
                https://twitter.com/xel_em_
              </a>
            </div>
          </div>
          <div className="mb-2">
            <p className="text-lg font-bold mb-1">LinkedIn</p>
            <div className="flex">
              <img src="linkedin.png" alt="linkedin" height={24} width={24} />
              <a href="https://www.linkedin.com/in/xelem/" className="ml-4">
                https://www.linkedin.com/in/xelem
              </a>
            </div>
          </div>

          <div className="mt-6">
            <a
              href="https://wa.me/+2348132530997"
              className="button flex w-[70%] md:w-[40%]"
            >
              <img
                src="whatsapp-icon.png"
                alt="whatsapp"
                width={24}
                height={24}
              />
              <p className="ml-2">Send message</p>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
